import { Global } from '@emotion/react';
import '@/utils/i18n';

import React, { FC } from 'react';
import { ThemeProvider } from '@airwallex/theme';

import ExternalBillingHostedInvoiceRouter from './pages';
import ToastProvider from '@airwallex/toast';

export const Root: FC = () => {
  return (
    <ThemeProvider langKey="en">
      <Global
        styles={{
          input: {
            fontFamily: 'AxLLCircular, Helvetica, Arial, sans-serif',
          },
        }}
      />
      <ToastProvider container={document.body}>
        <ExternalBillingHostedInvoiceRouter />
      </ToastProvider>
    </ThemeProvider>
  );
};

export default Root;
